module.exports = __webpack_public_path__ + "media/04 festive.90174189.mp3";